import React from 'react';

const LayerBar = ({ layers, activeLayer, onChange, isMobile = false }) => {
  const layerNames = {
    back: 'Background',
    eyes: 'Eyes',
    hairs: 'Hair',
    mouth: 'Mouth',
    neck: 'Neck',
    noses: 'Nose'
  };

  const layerIcons = {
    back: '🎨',
    eyes: '👁️',
    hairs: '💇',
    mouth: '👄',
    neck: '👔',
    noses: '👃'
  };

  if (isMobile) {
    return (
      <div className="layer-bar layer-bar--mobile">
        <div className="layer-bar-scroll">
          {Object.keys(layers).map(layerKey => (
            <button
              key={layerKey}
              className={`layer-pill layer-pill--mobile ${activeLayer === layerKey ? 'active' : ''}`}
              onClick={() => onChange(layerKey)}
            >
              <div className="layer-pill-icon">
                {layers[layerKey]?.[0] ? (
                  <img 
                    src={layers[layerKey][0].src} 
                    alt={layerNames[layerKey]}
                    className="layer-pill-thumbnail"
                  />
                ) : (
                  <span className="layer-pill-fallback">{layerIcons[layerKey]}</span>
                )}
              </div>
              <span className="layer-pill-label">{layerNames[layerKey]}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="layer-bar layer-bar--desktop">
      {Object.keys(layers).map(layerKey => (
        <button
          key={layerKey}
          className={`layer-pill layer-pill--desktop ${activeLayer === layerKey ? 'active' : ''}`}
          onClick={() => onChange(layerKey)}
        >
          <div className="layer-pill-icon">
            {layers[layerKey]?.[0] ? (
              <img 
                src={layers[layerKey][0].src} 
                alt={layerNames[layerKey]}
                className="layer-pill-thumbnail"
              />
            ) : (
              <span className="layer-pill-fallback">{layerIcons[layerKey]}</span>
            )}
          </div>
          <span className="layer-pill-label">{layerNames[layerKey]}</span>
        </button>
      ))}
    </div>
  );
};

export default LayerBar;
